export const forgotPassword = {
  pageTitle: 'Forgot your password?',
  infoAlert: 'If your email address exists in our system, you will receive a password recovery link in your email shortly.',
  formSubmitButton: 'Send reset instructions',
  backButton: 'Back to sign in',
  errors: {
    email: 'Email must be a valid email'
  }
};
